exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popup_btns[data-v-7319e672]{display:flex;flex-direction:row;justify-content:space-between}", ""]);

// exports
